export default function Ad() {
  return (
    <>
      <iframe data-aa='1980365' src='//ad.a-ads.com/1980365?size=300x250' style={{ width: '300px', height: '250px', margin: '50px', border: '0px', padding: '0', overflow: 'hidden', backgroundColor: 'transparent' }}></iframe>
    </>
  );
}